import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { avatar, searchIcon } from "../../../assets/media/chat/ChatIcons";
import { withRouter } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { objectsConstants } from "../../../redux/constant/objects-constant";

function TravelersList(props) {
    const [travelersList, setTravelersList] = useState([]);
    const [travelersListClone, setTravelersListClone] = useState([]);
    const [groups, setGroups] = useState([]);
    const [groupsCLone, setGroupsClone] = useState([]);
    const [selectedTab, setTab] = useState(0);
    const [searchQuery, setQuery] = useState('');
    const [selectedSenderId, setSelectedSenderId] = useState(null);
    useEffect(() => {
        setTravelersList([...props.travelersList]);
        setTravelersListClone([...props.travelersList]);
    }, [props.travelersList]);

    useEffect(() => {
        if (props.groups) {
            setGroups([...props.groups]);
            setGroupsClone([...props.groups]);
        }
    }, [props.groups]);

    function searchUser(e) {
        const { value } = e.target;
        setQuery(value);
        if (value) {
            const temp = travelersListClone.filter(tvl => {
                const name = tvl.firstName.toLowerCase() + ' ' + tvl.lastName.toLowerCase();
                if (name.includes(value.toLowerCase().trim()))
                    return true;
            })
            setTravelersList(temp);
        } else {
            setTravelersList(travelersListClone);
        }
    }

    function travelerSelected(traveler) {
        // traveler.type === 'sender' ? props.setSelectedSender(traveler) : props.setSelectedReceiver(traveler);
        console.log('travelerSelected', traveler);
        if (traveler.type === 'sender') {
            props.setSelectedSender(traveler);
            if (selectedTab === 1) {
                setSelectedSenderId(traveler.sent_by);
            }
        } else {
            // console.log('travelerSelected', traveler);
            if(traveler.type === 1) {
                setSelectedSenderId(traveler.sent_by);
            }
            else {
                props.setSelectedReceiver(traveler);
            }
        }
    }

    function senderSelected(traveler) {
        if (traveler === '91') {
            console.log("objectsConstants.defaultAdminUser", objectsConstants.defaultAdminUser);
            
            props.setSelectedSender(objectsConstants.defaultAdminUser);
        } else {
            props.setSelectedSender(props.usersMap[traveler]);
        }
        setSelectedSenderId(traveler);
        // props.setSelectedReceiver(traveler);
    }

    function groupSelected(group) {
        props.setSelectedGroup(group);
    }

    function searchGroups(e) {
        const { value } = e.target;
        setQuery(value);
        if (value) {
            const temp = groupsCLone.filter(group => {
                const name = group.group_name.toLowerCase();
                if (name.includes(value.toLowerCase().trim()))
                    return true;
            })
            setGroups(temp);
        } else {
            setGroups(groupsCLone);
        }
    }

    function setTabIndex(index) {
        setTab(index);
        if (index !== selectedTab) {
            setQuery('');
            setGroups(groupsCLone);
            setTravelersList(travelersListClone);
            // props.allMessageHandler(true);
            if (props.setSelectedSender) {
                setSelectedSenderId(null);
                // props.setSender(undefined);
                props.setSelectedSender(null);
            }
        }
    }


    return (
        <div id="travelers-list-container">
            <h2 id="chat-header">{props.header}</h2>
            <div className="chat-search-field">
                <input type="text"
                    placeholder="Search Travelers"
                    className="form-control"
                    log={console.log('selectedTab', selectedTab)}
                    onChange={(e) => { selectedTab === 0 ? searchUser(e) : searchGroups(e) }}
                    value={searchQuery}
                />
            </div>
            <Tabs selectedIndex={selectedTab} onSelect={index => { setTabIndex(index); if (index !== selectedTab) setQuery(''); if (typeof props.allMessageHandler === 'function') {
                const isAllMessagesTab = props.type !== 'receivers' && ( index === 1 || index === 2);
                props.allMessageHandler(isAllMessagesTab, index);
                }  }} >
                <TabList className="chat-tabs-list" style={{paddingLeft: 0}}>
                    <Tab id="details" style={{ fontSize: 17 }}>
                        <span>All Chat</span>
                    </Tab>
                    {
                        props.type !== 'receivers' &&
                        <Tab id="details" style={{ fontSize: 17 }}>
                            <span>{props.is_allow_one_to_one_chat ? 'Message All' : 'Announcements'}</span>
                        </Tab>
                    }
                    {/* {
                        props.type === 'receivers' &&
                        <Tab id="details" style={{ fontSize: 17 }}>
                            <span>Groups</span>
                        </Tab>
                    } */}
                    {
                        props.type === 'senders' &&
                        <Tab id="details" style={{ fontSize: 17 }}>
                            <span>Groups</span>
                        </Tab>
                    }
                </TabList>
                <TabPanel>
                    <div>
                        {
                            travelersList.length > 0 ?
                                travelersList.map(tvl => {
                                    if(!tvl.firstName || tvl.firstName == undefined) {
                                        return ''
                                    }
                                    return <div
                                        className={`chat-user-info bb ${tvl.selected ? 'selected' : ''}`}
                                        key={`${tvl.id}-${Math.random()}`}
                                        onClick={() => { travelerSelected(tvl) }}>
                                        <div
                                            // log={console.log('tvl ......... ', tvl)}
                                        >
                                            <img src={avatar} alt="avatar" />
                                        </div>
                                        {tvl.deleted_at && tvl.deleted_at > 1 ?
                                            <del style={{color:"#999"}}>{tvl.firstName} {tvl.lastName}</del>
                                            :
                                            tvl.firstName &&
                                                <div>{tvl.firstName} {tvl.lastName}</div>

                                        }
                                    </div>
                                })
                                : 'No User Found!'
                        }
                    </div>
                </TabPanel>
                {
                    props.type !== 'receivers' &&
                    <TabPanel>
                        <div>
                            {/* Message All Content */}
                            {props.all_messages && props.all_messages.length > 0 ? (
                                // selectedSenderId &&
                                // ? (
                                    // Filter messages by selected sender
                                    // props.all_messages
                                    // // .filter(msg => msg.sent_by === selectedSenderId)
                                    // .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
                                    // .map((msg, index) => (
                                    //     <div
                                    //     className="chat-message-info"
                                    //     key={`${msg.id}-${index}`}
                                    //     >
                                    //     <div>
                                    //         <img src={avatar} alt="avatar" />
                                    //     </div>
                                    //     <div>
                                    //         <strong>{msg.sender_first_name} {msg.sender_last_name}:</strong> {msg.message}
                                    //         <br />
                                    //         <small>{new Date(msg.created_at).toLocaleString()}</small>
                                    //     </div>
                                    //     </div>
                                    // ))
                                // ) : (
                                    // Step 1: Get unique senders (by sent_by)
                                    Array.from(
                                        new Map(
                                        props.all_messages.map(msg => [msg.sent_by, msg]) // unique by sender ID
                                        ).values()
                                    )
                                    .sort((a, b) => a.sender_first_name.localeCompare(b.sender_first_name))
                                    .map((sender, index) => (
                                        <div
                                        className={`chat-user-info cc ${sender.selected ? 'selected' : ''}`}
                                        // log={console.log("sender", sender)}
                                        key={`${sender.sent_by}-${index}`}
                                        onClick={() => senderSelected(sender.sent_by)}
                                        // onClick={() => { groupSelected(sender) }}
                                        >
                                        <div>
                                            <img src={avatar} alt="avatar" />
                                        </div>

                                        {/* Step 2: Handle deleted users */}
                                        {(props.usersMap[sender.sent_by] && props.usersMap[sender.sent_by].deleted_at && props.usersMap[sender.sent_by].deleted_at > 1) ? (
                                            <del style={{ color: '#999' }}>
                                            {sender.sender_first_name} {sender.sender_last_name}
                                            </del>
                                        ) : (
                                            <div>
                                            {sender.sender_first_name} {sender.sender_last_name}
                                            </div>
                                        )}
                                        </div>
                                    ))
                                // )
                            ) : (
                                <div>No Messages Found!</div>
                            )}
                        </div>
                    </TabPanel>

                }
                {
                    props.type === 'receivers' &&
                    <TabPanel>
                        <div className="">
                            <div>
                                {
                                    groups.length > 0 ?
                                        groups.map(group => {
                                            return <div
                                                className={`chat-user-info aa ${group.selected ? 'selected' : ''}`}
                                                key={group.id}
                                                onClick={() => { groupSelected(group) }}>
                                                <div>
                                                    <img src={avatar} alt="avatar" />
                                                </div>
                                                {group.deleted_at && group.deleted_at > 1 ?
                                                    <del style={{color:"#999"}}>{group.group_name}</del>
                                                    :
                                                    <div>{group.group_name}</div>
                                                }
                                            </div>
                                        })
                                        :
                                        'No Groups Found!'
                                }
                            </div>
                        </div>
                    </TabPanel>
                }

                
                {
                    props.type === 'senders' &&
                    <TabPanel>
                        <div className="">
                            <div>
                                {
                                    groups.length > 0 ?
                                        groups.map(group => {
                                            return <div
                                                className={`chat-user-info aa ${group.selected ? 'selected' : ''}`}
                                                key={group.id}
                                                onClick={() => { groupSelected(group) }}>
                                                <div>
                                                    <img src={avatar} alt="avatar" />
                                                </div>
                                                {group.deleted_at && group.deleted_at > 1 ?
                                                    <del style={{color:"#999"}}>{group.group_name}</del>
                                                    :
                                                    <div>{group.group_name}</div>
                                                }
                                            </div>
                                        })
                                        :
                                        'No Groups Found!'
                                }
                            </div>
                        </div>
                    </TabPanel>
                }
            </Tabs>
            <div>
                {
                    props.type !== 'receivers' &&
                    // <div>
                    //     <div>
                    //         <div>
                    //             <input type="text" placeholder="Search Travelers" className="form-control" onChange={searchUser} />
                    //         </div>
                    //         <div>
                    //             {
                    //                 travelersList.length > 0 &&
                    //                 travelersList.map(tvl => {
                    //                     return <div className="flex"
                    //                         style={{ background: `${tvl.selected ? 'tomato' : ''}` }} key={tvl.id}
                    //                         onClick={() => { travelerSelected(tvl) }}>
                    //                         <div>
                    //                             <img src={avatar} alt="avatar" />
                    //                             {/* <img src={require('../../../assets/media/chat/avatar.svg').default} alt="avatar" /> */}
                    //                         </div>
                    //                         <div>{tvl.firstName} {tvl.lastName}</div>
                    //                     </div>
                    //                 })
                    //             }
                    //         </div>
                    //     </div>
                    // </div>
                    <span></span>
                }
            </div>
        </div>
    );
}

const mapDispatchToProps = dispatch => {
    return ({
        // errorAlert: (e) => {
        //     dispatch(alertActions.error(e))
        // },
        // successAlert: (msg) => {
        //     dispatch(alertActions.success(msg))
        // },
    });
};

export default withRouter(connect(null, mapDispatchToProps)(TravelersList));
